<template>
  <!-- 本组件为：仪表图，如全部设备详情页的soh -->
  <div :class="className" :style="{height:height,width:width}" />
</template>

<script>
import echarts from 'echarts'
require('echarts/theme/macarons') // echarts theme
import resize from './resize'
// var colorList = ['#afa3f5', '#00d488', '#3feed4', '#3bafff', '#f1bb4c', 'rgba(250,250,250,0.5)']
var colorList = [
  '#30c7c9', '#b6a2de', '#59b1ef', '#ffb980',
  '#d87980', '#8c98b3', '#e5ce2c', '#97b552',
  '#996666', '#cc6699', '#339999', '#9966cc',
  '#6699cc', '#ff9933', '#cc6666', '#666699'
]
export default {
  mixins: [resize],
  props: {
    className: {
      type: String,
      default: 'chart'
    },
    width: {
      type: String,
      default: '100%'
    },
    height: {
      type: String,
      default: '300px'
    },
    seriesData: {
      type: Number,
      default: 0
    }
  },
  data () {
    return {
      chart: null,
      legendData: []
    }
  },
  watch: {
    seriesData (val) {
      this.seriesData = val // 把新值赋值给我们的属性数据
      this.initChart() // 刷新echarts图表

    }
  },
  mounted () {
    this.$nextTick(() => {
    })
    setTimeout(() => {
      this.initChart()
    }, 500)
  },
  beforeDestroy () {
    if (!this.chart) {
      return
    }
    this.chart.dispose()
    this.chart = null
  },
  methods: {
    initChart () {
      this.chart = echarts.init(this.$el, 'macarons')
      var option = {
        title: {
          show: false
        },
        grid: [{
          show: false,
          backgroundColor: 'rgba(0,0,0,0)',
          borderWidth: 0,
          y: 'bottom'
        }],
        series: [{
          type: 'gauge',
          startAngle: 180,
          endAngle: 0,
          min: 0,
          max: 100,
          radius: '70%',
          // splitNumber: 3,
          center: ['50%', '65%'],
          axisLine: {
            show: true,
            lineStyle: {
              width: 50,
              // shadowBlur: 5, // 仪表盘的阴影
              // 2021.11月份，按jeff的要求改成：       优：90~100   良：70~90   中：50~70   差：小于50
              color: [
                [0, 'transparent'],
                [0.49, '#e4101f'],
                [0.50, 'transparent'],
                [0.69, '#f09426'],
                [0.70, 'transparent'],
                [0.89, '#0cb275'],
                [0.90, 'transparent'],
                [1, '#A9D252']
              ]
            }
          },
          axisTick: {
            show: false
          },
          axisLabel: {
            show: false
          },
          splitLine: {
            show: false
          },
          pointer: {
            width: '3%',
            length: '90%',
            color: 'black'
          },
          itemStyle: {
            normal: {
              color: 'rgba(255, 255, 255)',
              shadowBlur: 2 // 指针的阴影
            }
          },
          title: {
            show: false
          },
          detail: {
            show: false
          },
          data: [{
            value: this.seriesData
          }]
        }]
      }
      this.chart.setOption(option, true)
    }
  }
}
</script>
